<h1 mat-dialog-title>{{getTitle()}}</h1>
<mat-dialog-content autocomplete="off">
  @if (!excludeUseCalculated) {
    <p class="intro">{{getToggleHint()}}</p>
    <mat-slide-toggle class="toggle" labelPosition="after" [checked]="useInputFrequency" [disabled]="readonly" (change)="changeInputFrequency($event)">{{getCalculatedLabel()}}</mat-slide-toggle>
  }

  @if (showDuration()) {
    <section>
      <p>{{getHeadingText()}}</p>
      <div class="duration">
        @for (f of DURATION_FIELDS; track f.field) {
          <mat-form-field appearance="fill">
            <mat-label>{{f.label}}</mat-label>
            <input matInput type="number" min="0" [(ngModel)]="duration[f.field]" [id]="'duration-' + f.field" [disabled]="readonly">
          </mat-form-field>
        }
      </div>
      @if (durationError()) {
        <mat-error>{{durationError()}}</mat-error>
      }@else {
        <p class="summary">Total: {{getDurationDescription()}}</p>
      }
    </section>
  }

  @if (showFrequency()) {
    <section>
      @if (isAction) {
        <p>How often is this action taken?</p>
        <mat-form-field appearance="fill" class="occurrences">
          <mat-label>Number of times</mat-label>
          <input matInput type="number" min="0" [(ngModel)]="frequency.ocurrences" id="frequency-occurrences" [disabled]="readonly">
          <span matTextSuffix>time(s)</span>
          @if (occurrencesError()) {
            <mat-error>{{occurrencesError()}}</mat-error>
          }
        </mat-form-field>
      }

      <span>Every</span>
      <mat-radio-group class="tempo-radio-group" [(ngModel)]="frequency.type" [disabled]="readonly" aria-label="How often">
        @for (choice of FREQUENCY_CHOICES; track choice) {
          <mat-radio-button [value]="choice">{{choice}}</mat-radio-button>
          @if (choice === FREQUENCY_TYPE.SPECIFIC_DAYS && frequency.type === FREQUENCY_TYPE.SPECIFIC_DAYS) {
            <ul>
              @for (day of DAYS_OF_WEEK; track day) {
                <li><mat-checkbox (change)="checkBoxChange($event, day)" [checked]="isDayChecked(day)" [disabled]="readonly">{{day}}</mat-checkbox></li>
              }
            </ul>
            @if (daysError()) {
              <mat-error class="days-error">{{daysError()}}</mat-error>
            }
          }
        }
      </mat-radio-group>

      @if (frequency.type === FREQUENCY_TYPE.DAY) {
        <mat-form-field appearance="fill" class="per-year">
          <mat-label>Number of days per year</mat-label>
          <input matInput type="number" min="1" max="366" [(ngModel)]="frequency.daysPerYear" placeholder="365" id="frequency-days-per-year" [disabled]="readonly">
          <mat-hint>Leave blank for 365</mat-hint>
        </mat-form-field>
      }@else if (usesWeeksPerYear()) {
        <mat-form-field appearance="fill" class="per-year">
          <mat-label>Number of weeks per year</mat-label>
          <input matInput type="number" min="1" max="53" [(ngModel)]="frequency.weeksPerYear" placeholder="52" id="frequency-weeks-per-year" [disabled]="readonly">
          <mat-hint>Leave blank for 52</mat-hint>
        </mat-form-field>
      }
      @if (perYearError()) {
        <mat-error>{{perYearError()}}</mat-error>
      }
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (readonly) {
    <button mat-button (click)="dialogRef.close()" cdkFocusInitial>Close</button>
  }@else {
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="save()" [disabled]="!isValid()">Save</button>
  }
</mat-dialog-actions>
